import React from 'react';
import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from '@mui/material';

interface CustomTooltipProps extends Omit<MuiTooltipProps, 'title'> {
  title: string;
}

const Tooltip: React.FC<CustomTooltipProps> = ({ title, children, ...props }) => {
  return (
    <MuiTooltip title={title} arrow enterDelay={100} leaveDelay={10} placement="top-start" {...props}>
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
